/**
 * 友だち招待のシェア文面と各SNSの共有URL。
 *
 * 文面は仕様書（2026-08-14）のたたき台をそのまま使う。
 * クレジットがもらえるのは招待した人だけなので、「登録するともらえる」と
 * 読める表現は入れない。
 */
export const SHARE_MESSAGE =
  'URLを入れるだけで広告バナーが作れるTaskyを使っています。7日間無料で試せます';

export const MAIL_SUBJECT = 'Tasky を使ってみませんか';

/**
 * Instagram だけは Web の共有インテントが存在しないため、
 * 文面＋URLをクリップボードに入れてから Instagram を開く。
 */
export const INSTAGRAM_URL = 'https://www.instagram.com/';

export const buildShareText = (inviteUrl: string): string => `${SHARE_MESSAGE}\n${inviteUrl}`;

export const buildXShareUrl = (inviteUrl: string): string =>
  `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_MESSAGE)}&url=${encodeURIComponent(inviteUrl)}`;

export const buildFacebookShareUrl = (inviteUrl: string): string =>
  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(inviteUrl)}`;

export const buildLineShareUrl = (inviteUrl: string): string =>
  `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(inviteUrl)}&text=${encodeURIComponent(SHARE_MESSAGE)}`;

/**
 * メーラーを開く mailto。宛先はユーザーが自分で入れる。
 *
 * サーバーから招待メールを送る方式にはしていない。自社ドメインから任意の
 * アドレスへ送れる口はスパムの温床になり、レート制限・バウンス処理・配信停止の
 * 設計が別途必要になるため（仕様の受け入れ条件にも含まれていない）。
 */
export const buildMailtoUrl = (inviteUrl: string): string =>
  `mailto:?subject=${encodeURIComponent(MAIL_SUBJECT)}&body=${encodeURIComponent(buildShareText(inviteUrl))}`;
